import { render, staticRenderFns } from "./xTable.vue?vue&type=template&id=02c83197"
import script from "./xTable.vue?vue&type=script&lang=js"
export * from "./xTable.vue?vue&type=script&lang=js"
import style0 from "./xTable.vue?vue&type=style&index=0&id=02c83197&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports